<template>
	<path
		d="M11 14V15.25C11 15.6642 10.6642 16 10.25 16H1.75C1.33578 16 1 15.6642 1 15.25V3.75C1 3.33578 1.33578 3 1.75 3H4V12.25C4 13.215 4.78503 14 5.75 14H11ZM11 3.25V0H5.75C5.33578 0 5 0.335781 5 0.75V12.25C5 12.6642 5.33578 13 5.75 13H14.25C14.6642 13 15 12.6642 15 12.25V4H11.75C11.3375 4 11 3.6625 11 3.25ZM14.7803 2.28034L12.7197 0.219656C12.579 0.0790133 12.3882 1.03999e-06 12.1893 0L12 0V3H15V2.81066C15 2.61175 14.921 2.42099 14.7803 2.28034Z"
		fill="#E2E2E2"
	/>
</template>
